(() => {
  document.querySelectorAll('[data-nv-localization]').forEach(select => {
    select.addEventListener('change', () => {
      const form = select.form;
      if (!form || !select.value) return;
      const controls = form.closest('.nv-locale-controls');
      if (select.name === 'language_code' && controls?.classList.contains('nv-locale-controls--prelaunch')) {
        const language = controls.querySelector('select[name="language_code"]');
        const languageRoot = language?.selectedOptions[0]?.dataset.nvLanguageRoot;
        if (languageRoot) {
          window.location.assign(languageRoot.replace(/\/$/, '') + '/password' + window.location.search);
          return;
        }
      }
      form.requestSubmit();
    });
  });
})();
